var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-health.1fd550c9.png","uri@2x": __webpack_public_path__ + "icon-health.ba74ee2b.png","uri@3x": __webpack_public_path__ + "icon-health.67c3f33c.png",
    width: 32,
    height: 32
});